import React from 'react';
import PropTypes from 'prop-types';

export const FormattedPlainText = ({ text }) => {
  if (!text) return null;

  const paragraphs = text.split(/\n\n+/).map((paragraph, paragraphIndex) => {
    const lines = paragraph.split(/\n/).flatMap((line, lineIndex, lineArray) => {
      if (lineIndex === lineArray.length - 1) return [line];
      return [line, <br key={lineIndex} />];
    });

    return <p key={paragraphIndex}>{lines}</p>;
  });

  return paragraphs;
}

FormattedPlainText.propTypes = {
  text: PropTypes.string.isRequired,
};
